import React, { useEffect, useRef, useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export default function SignaturePad({ onSubmit, submitting }) {
  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [hasInk, setHasInk] = useState(false);
  const [name, setName] = useState("");

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const dpr = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    const ctx = canvas.getContext("2d");
    ctx.scale(dpr, dpr);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#0A2540";
  }, []);

  const getPos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - r.left, y: t.clientY - r.top };
  };

  const start = (e) => {
    e.preventDefault();
    const { x, y } = getPos(e);
    const ctx = canvasRef.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(x, y);
    setDrawing(true);
  };
  const move = (e) => {
    if (!drawing) return;
    e.preventDefault();
    const { x, y } = getPos(e);
    const ctx = canvasRef.current.getContext("2d");
    ctx.lineTo(x, y);
    ctx.stroke();
    setHasInk(true);
  };
  const end = () => setDrawing(false);

  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setHasInk(false);
  };

  const submit = () => {
    if (!hasInk || !name.trim()) return;
    const dataUrl = canvasRef.current.toDataURL("image/png");
    onSubmit({ signature_data: dataUrl, signature_name: name.trim() });
  };

  return (
    <div className="space-y-4" data-testid="signature-pad">
      <div>
        <Label htmlFor="sig-name" className="text-xs uppercase tracking-wider text-[#6B7280]">Full legal name</Label>
        <Input id="sig-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Jane Q. Attorney" className="mt-1.5" data-testid="signature-name-input" />
      </div>
      <div>
        <Label className="text-xs uppercase tracking-wider text-[#6B7280]">Sign below</Label>
        <div className="mt-1.5 rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] overflow-hidden">
          <canvas
            ref={canvasRef}
            className="block w-full h-40 touch-none"
            onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
            onTouchStart={start} onTouchMove={move} onTouchEnd={end}
            data-testid="signature-canvas"
          />
        </div>
      </div>
      <div className="flex gap-3">
        <Button variant="outline" onClick={clear} data-testid="signature-clear-btn">Clear</Button>
        <Button onClick={submit} disabled={!hasInk || !name.trim() || submitting} className="btn-primary-navy" data-testid="signature-submit-btn">
          {submitting ? "Saving…" : "Submit signature"}
        </Button>
      </div>
    </div>
  );
}
